import { parseDocumentCookie } from "src/utilities/cookies"

export type FirstPromoterCookies = {
  _fprom_tid: string
  _fprom_ref: string
}

export function parseFirstPromoterCookies() {
  const { _fprom_tid, _fprom_ref } = parseDocumentCookie()

  if (!_fprom_tid || !_fprom_ref) {
    return null
  }

  const cookies: FirstPromoterCookies = { _fprom_tid, _fprom_ref }

  return cookies
}
